import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import { 
  FaUser, FaGlobe, FaWrench, FaSignOutAlt, FaServer, FaClock, 
  FaTasks, FaCar, FaExclamationTriangle, FaCrown, FaRegClock, 
  FaFilePdf, FaCalendarAlt, FaPrint, FaLink, FaExternalLinkAlt,
  FaBuilding, FaUsers, FaDatabase, FaBoxes, FaMoneyBillWave,
  FaCogs, FaClipboardList, FaChartLine, FaTachometerAlt,
  FaMapMarkerAlt, FaHome, FaCity, FaEnvelope, FaHashtag,
  FaBars, FaTimes, FaClipboardCheck, FaFileAlt, FaFileInvoiceDollar,
  FaStamp, FaFileSignature, FaExchangeAlt,
} from "react-icons/fa";
import { IoMdBusiness, IoMdClipboard } from "react-icons/io";
import { MdSettings, MdBackup, MdStorefront, MdRequestPage } from "react-icons/md";
import { GiTakeMyMoney, GiMoneyStack } from "react-icons/gi";
import axios from 'axios';
import { decodeToken } from "react-jwt";
import Header from '../others/Header';
import { useNavigate, Link } from 'react-router-dom';
import { isExpired } from "react-jwt";
import config from '../config/config';
import Modal from 'react-modal';
import { useToast } from '../components/ToastContext';
import RequerimentoDetranModal from '../components/RequerimentoDetranModal';

Modal.setAppElement('#root');

const Home = () => {
  const navigate = useNavigate();
  const [canRender, setCanRender] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRequerimentoModal, setShowRequerimentoModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [userData, setUserData] = useState(null);
  const { API_BASE_URL } = config;

  const { addToast } = useToast();
  const [showRelatorioModal, setShowRelatorioModal] = useState(false);
  const [relatorioData, setRelatorioData] = useState({
    dataInicio: '',
    dataFim: ''
  });
  const [loadingRelatorio, setLoadingRelatorio] = useState(false);
  const [usefulLinks, setUsefulLinks] = useState([]);
  const [lembretesHoje, setLembretesHoje] = useState([]);

  // Detecta se é desktop para abrir sidebar por padrão
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    loadUsefulLinks();
  }, []);

  // ── Lembretes da Agenda para hoje. A data é a LOCAL do usuário (toISOString() usa UTC e, à noite, viraria amanhã).
  // GET /agenda/dia/{AAAA-MM-DD}. Falha não atrapalha a Home: só não mostra o quadro.
  // O back já devolve em ordem de horário; concluídos não aparecem na Home (continuam na tela da Agenda).
  useEffect(() => {
    const h = new Date();
    const hoje = `${h.getFullYear()}-${String(h.getMonth() + 1).padStart(2, '0')}-${String(h.getDate()).padStart(2, '0')}`;
    axios.get(`${API_BASE_URL}/agenda/dia/${hoje}`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('jwtToken')}` }
    })
      .then((response) => setLembretesHoje((response.data || []).filter(l => !l.concluido)))
      .catch((error) => console.error('Erro ao carregar lembretes de hoje:', error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // X no compromisso: marca como feito e tira da Home na hora; se a API falhar, ele volta para a lista
  // PUT /agenda/{id}/concluido
  const concluirLembrete = async (lembrete) => {
    setLembretesHoje(lista => lista.filter(l => l.idLembrete !== lembrete.idLembrete));
    try {
      await axios.put(`${API_BASE_URL}/agenda/${lembrete.idLembrete}/concluido`, { concluido: true }, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('jwtToken')}` }
      });
      addToast('success', 'Compromisso concluído!');
    } catch (error) {
      console.error('Erro ao concluir lembrete:', error);
      addToast('error', error.response?.data?.message || 'Erro ao concluir o compromisso');
      setLembretesHoje(lista => [...lista, lembrete].sort(
        (a, b) => (a.horaLembrete || '99:99').localeCompare(b.horaLembrete || '99:99') || a.idLembrete - b.idLembrete
      ));
    }
  };

  const loadUsefulLinks = async () => {
    try {
      const token = localStorage.getItem('jwtToken');
      const response = await axios.get(`${API_BASE_URL}/links`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setUsefulLinks(response.data);
    } catch (error) {
      console.error('Erro ao carregar links úteis:', error);
    }
  };

  const getAuthHeader = () => {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    };
  };

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token === null || typeof token === "undefined" || isExpired(token)) {
      window.location.href = "/login";
    } else {
      const decoded = decodeToken(token);
      setUserData(decoded);
      if (decoded?.needUpdatePass) {
        setShowModal(true);
      }
      setCanRender(true);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('jwtToken');
    navigate('/login');
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.currentPassword) errors.currentPassword = "A senha atual é obrigatória.";
    if (!formData.newPassword) {
      errors.newPassword = "A nova senha é obrigatória.";
    } else if (formData.newPassword.length < 10) {
      errors.newPassword = "A senha deve ter no mínimo 10 caracteres.";
    } else if (!/(?=.*[a-zA-Z])/.test(formData.newPassword)) {
      errors.newPassword = "A senha deve conter pelo menos uma letra.";
    } else if (!/(?=.*\d)/.test(formData.newPassword)) {
      errors.newPassword = "A senha deve conter pelo menos um número.";
    } else if (!/(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(formData.newPassword)) {
      errors.newPassword = "A senha deve conter pelo menos um caractere especial.";
    }
    if (!formData.confirmPassword) {
      errors.confirmPassword = "A confirmação de senha é obrigatória.";
    } else if (formData.newPassword !== formData.confirmPassword) {
      errors.confirmPassword = "As senhas não coincidem.";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("jwtToken");
    if (validateForm()) {
      try {
        const response = await fetch(`${API_BASE_URL}/usuarios/updatePassword`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(formData)
        });
        if (response.status === 401) {
          const errorMessage = await response.text();
          setFormErrors({ currentPassword: errorMessage });
        } else if (response.ok) {
          const data = await response.json();
          localStorage.setItem("jwtToken", data.token);
          setShowModal(false);
          const decoded = decodeToken(data.token);
          setUserData(decoded);
          addToast('success', 'Senha atualizada com sucesso!');
        } else {
          addToast('error', 'Erro ao atualizar senha');
        }
      } catch (error) {
        addToast('error', 'Erro de conexão');
      }
    }
  };

  const formatarDataParaAPI = (data) => data.toISOString().split('T')[0];

  const setPeriodoHoje = () => {
    const hoje = new Date();
    setRelatorioData({
      dataInicio: formatarDataParaAPI(hoje),
      dataFim: formatarDataParaAPI(hoje)
    });
  };

  const validarDatas = () => {
    if (!relatorioData.dataInicio || !relatorioData.dataFim) {
      addToast('warning', 'Por favor, selecione ambas as datas');
      return false;
    }
    if (new Date(relatorioData.dataInicio) > new Date(relatorioData.dataFim)) {
      addToast('warning', 'A data de início não pode ser maior que a data de fim');
      return false;
    }
    return true;
  };

  const formatarTipoPlano = (tipo) => {
    switch (tipo) {
      case 'TESTE': return 'Plano Teste';
      case 'DEFINITIVO': return 'Plano Definitivo';
      case 'MENSAL': return 'Plano Mensal';
      default: return tipo;
    }
  };

  const getPlanoIcon = (tipo) => {
    switch (tipo) {
      case 'TESTE': return <FaRegClock size={14} />;
      case 'DEFINITIVO': return <FaCrown size={14} />;
      case 'MENSAL': return <FaCrown size={14} />;
      default: return <FaCrown size={14} />;
    }
  };

  const gerarRelatorioCaixa = async () => {
    if (!validarDatas()) return;
    setLoadingRelatorio(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/financeiro/relatorio/${relatorioData.dataInicio}`,
        getAuthHeader()
      );
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, '_blank');
      if (!newWindow) {
        const link = document.createElement('a');
        link.href = url;
        link.download = `relatorio-caixa-${relatorioData.dataInicio}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      setShowRelatorioModal(false);
      addToast('success', 'Relatório gerado com sucesso!');
    } catch (error) {
      addToast('error', 'Erro ao gerar relatório: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoadingRelatorio(false);
    }
  };

  // ─── Permissões por role ───────────────────────────────────────────────────
  const ROLES_MANAGER_ONLY  = ['MANAGER'];
  const ROLES_GERENTE       = ['MANAGER', 'GERENTE', 'ADMIN'];
  const ROLES_GERENTE_ALL   = ['MANAGER', 'GERENTE', 'ADMIN', 'FUNCIONARIO', 'COLABORADOR'];
  const ROLES_FINANCEIRO    = ['MANAGER', 'GERENTE', 'ADMIN'];
  // ─── Ofícios/Memorandos: acesso restrito a Manager e Gerente/Coordenador —
  // diferente de ROLES_FINANCEIRO, aqui o ADMIN NÃO tem acesso ───────────────
  const ROLES_OFICIOS_MEMORANDOS = ['MANAGER', 'GERENTE'];

  const menuItems = [
    { id: 'ordemServico',         label: 'Ordem de Serviço',         icon: <FaClipboardList size={20} />, path: '/ordemServico',         roles: ROLES_GERENTE_ALL },
    { id: 'clientes',             label: 'Clientes',                 icon: <FaUsers size={20} />,         path: '/clientes',             roles: ROLES_GERENTE_ALL },
    // ─── CORREÇÃO: Requerimentos agora abre o modal via callback ─────────────
    // path usado no botão direito / Ctrl+clique ("Abrir em nova aba"), que abre a página /requerimentos
    { id: 'requerimentos',        label: 'Requerimentos',            icon: <MdRequestPage size={20} />,   path: '/requerimentos', onClick: () => setShowRequerimentoModal(true), roles: ROLES_GERENTE_ALL },
    // ─── Protocolo continua abrindo em nova aba ───────────────────────────────
    { id: 'protocoloAtendimento', label: 'Protocolo de Atendimento', icon: <FaFileAlt size={20} />,       path: '/protocoloAtendimento', newTab: true, roles: ROLES_GERENTE_ALL },
    // ─── Painel CRVA (CRLV-e / Procurações / Pix / ISSQN) — abre em nova aba ──
    { id: 'painelCRVA',           label: 'Planilhas de Gestão',      icon: <FaTasks size={20} />,         path: '/painel-crva',          newTab: true, roles: ROLES_GERENTE_ALL },
    { id: 'relatorios',           label: 'Relatórios',               icon: <FaChartLine size={20} />,     path: '/relatorios',           roles: ROLES_GERENTE_ALL },
    // ─── Agenda da empresa (lembretes por data), trazida do Truck Control — todos os perfis ──
    { id: 'agenda',               label: 'Agenda',                   icon: <FaCalendarAlt size={20} />,   path: '/agenda',               roles: ROLES_GERENTE_ALL },
    { id: 'saques',               label: 'Saques',                   icon: <GiTakeMyMoney size={20} />,   path: '/saques',               roles: ROLES_FINANCEIRO },
    { id: 'depositos',            label: 'Depósitos',                icon: <FaMoneyBillWave size={20} />, path: '/depositos',            roles: ROLES_FINANCEIRO },
    // ─── Área Fiscal (DPS / NFS-e Nacional) — abre em nova aba ────────────────
    { id: 'areaFiscal',           label: 'Área Fiscal',              icon: <FaFileInvoiceDollar size={20} />, path: '/area-fiscal',      newTab: true, roles: ROLES_FINANCEIRO },
    { id: 'produtos',             label: 'Produtos',                 icon: <FaBoxes size={20} />,         path: '/produtos',             roles: ROLES_FINANCEIRO },
    // ─── NOVO: Ofícios/Memorandos — Memorandos, Ofícios e EPROD com numeração
    // sequencial por ano. Mesmo nível de acesso de Produtos (Gerente/Admin/Manager) ──
    { id: 'oficiosMemorandos',    label: 'Ofícios/Memorandos',       icon: <FaStamp size={20} />,         path: '/oficios-memorandos',   roles: ROLES_OFICIOS_MEMORANDOS },
    // ─── Declarações e requerimentos de vistoria/DETRAN (só gera para imprimir, nada é salvo) ──
    { id: 'documentosComplementares', label: 'Documentos Complementares', icon: <FaFileSignature size={20} />, path: '/documentos-complementares', roles: ROLES_GERENTE_ALL },
    // ─── Cadastro de veículos (placa, chassi, RENAVAM...) com importação de CRLV-e/ATPV/CRV em massa ──
    { id: 'veiculos',             label: 'Veículos',                 icon: <FaCar size={20} />,           path: '/veiculos',             roles: ROLES_GERENTE_ALL },
    { id: 'digitalizacao',        label: 'Digitalização',            icon: <FaPrint size={20} />,         path: '/digitalizacao',        roles: ROLES_GERENTE_ALL },
    { id: 'usuarios',             label: 'Usuários',                 icon: <FaUser size={20} />,          path: '/usuarios',             roles: ROLES_GERENTE },
    { id: 'configuracoes',        label: 'Configurações',            icon: <MdSettings size={20} />,      path: '/settings',             roles: ROLES_GERENTE },
    // ─── Manager escolhe com qual empresa trabalhar (só vê os dados dela) ──
    { id: 'trocarEmpresa',        label: 'Trocar Empresa',           icon: <FaExchangeAlt size={20} />,   path: '/selecionar-empresa',   roles: ROLES_MANAGER_ONLY },
    { id: 'empresas',             label: 'Empresas',                 icon: <FaBuilding size={20} />,      path: '/cadastroEmpresas',     roles: ROLES_MANAGER_ONLY },
    { id: 'servidor',             label: 'Servidor',                 icon: <FaServer size={20} />,        path: '/server-info',          roles: ROLES_MANAGER_ONLY },
  ];

  const tipoUsuarioNormalizado = (userData?.tipoUsuario || '').toUpperCase();

  // Saudação do cabeçalho de boas-vindas
  const horaAtual = new Date().getHours();
  const saudacao = horaAtual < 12 ? 'Bom dia' : horaAtual < 18 ? 'Boa tarde' : 'Boa noite';
  const primeiroNome = (userData?.nomeUsuario || '').trim().split(/\s+/)[0] || '';
  const dataHojeTexto = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  const dataHoje = dataHojeTexto.charAt(0).toUpperCase() + dataHojeTexto.slice(1);

  const filteredMenuItems = menuItems.filter(item =>
    item.roles.includes(tipoUsuarioNormalizado)
  );

  // Os itens são links de verdade (<Link>): a navegação e o "abrir em nova aba" (newTab,
  // botão direito, Ctrl+clique, clique do meio) ficam por conta do navegador/react-router.
  const handleMenuItemClick = (e, item) => {
    const abrindoEmNovaAba = e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1;
    if (item.onClick && !abrindoEmNovaAba) {
      e.preventDefault();
      item.onClick();
    }
    if (window.innerWidth < 1024) {
      setSidebarOpen(false);
    }
  };

  return (
    <HomeBackground>
      {canRender && userData && (
        <HomeContainer>
          {/* Top Bar */}
          <TopBar>
            <TopBarContent>
              <MenuToggleButton onClick={() => setSidebarOpen(!sidebarOpen)}>
                {sidebarOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
              </MenuToggleButton>

              <LeftSection>
                <CompanyLogo>
                  <IoMdBusiness size={26} color="#fff" />
                </CompanyLogo>
                <CompanyInfo>
                  <CompanyName>{userData.empresaNomeFantasia || userData.empresaRazaoSocial || 'TimeTask'}</CompanyName>
                </CompanyInfo>
              </LeftSection>

              <RightSection>
                <UserSection>
                  <UserWelcome>
                    <UserAvatar>
                      <FaUser size={14} color="#fff" />
                    </UserAvatar>
                    <UserDetails>
                      <UserName>{userData.nomeUsuario}</UserName>
                      <UserRole>{(tipoUsuarioNormalizado === 'FUNCIONARIO' ? 'COLABORADOR' : tipoUsuarioNormalizado) || 'Usuário'}</UserRole>
                    </UserDetails>
                  </UserWelcome>

                  <LogoutButton onClick={handleLogout}>
                    <FaSignOutAlt size={13} />
                    <span>Sair</span>
                  </LogoutButton>
                </UserSection>

                <PlanInfoContainer>
                  <PlanLabel>Plano Atual:</PlanLabel>
                  <PlanInfoWrapper>
                    <PlanContainer>
                      <PlanIconContainer tipoPlano={userData.empresaTipoPlano}>
                        {getPlanoIcon(userData.empresaTipoPlano)}
                      </PlanIconContainer>
                      <PlanText tipoPlano={userData.empresaTipoPlano}>
                        {formatarTipoPlano(userData.empresaTipoPlano)}
                      </PlanText>
                    </PlanContainer>

                    {userData.empresaTipoPlano === 'TESTE' && userData.empresaDiasRestantes && (
                      <TestDaysWarning>
                        <FaExclamationTriangle size={11} />
                        <span>{userData.empresaDiasRestantes} dias restantes</span>
                      </TestDaysWarning>
                    )}
                  </PlanInfoWrapper>
                </PlanInfoContainer>
              </RightSection>
            </TopBarContent>
          </TopBar>

          {/* Main Content with Sidebar */}
          <MainContent>
            {sidebarOpen && <SidebarOverlay onClick={() => setSidebarOpen(false)} />}

            <Sidebar isOpen={sidebarOpen}>
              <SidebarHeader>
                <SidebarTitle>Menu</SidebarTitle>
                <SidebarCloseBtn onClick={() => setSidebarOpen(false)}>
                  <FaTimes size={16} />
                </SidebarCloseBtn>
              </SidebarHeader>
              <SidebarNav>
                {filteredMenuItems.map((item) => (
                  <SidebarItem
                    key={item.id}
                    to={item.path}
                    target={item.newTab ? '_blank' : undefined}
                    rel={item.newTab ? 'noopener noreferrer' : undefined}
                    onClick={(e) => handleMenuItemClick(e, item)}
                  >
                    <IconWrapper>{item.icon}</IconWrapper>
                    <ItemLabel>{item.label}</ItemLabel>
                  </SidebarItem>
                ))}
              </SidebarNav>
            </Sidebar>

            <ContentArea>
              <WelcomeMessage>
                <div>
                  <h1>{saudacao}{primeiroNome ? `, ${primeiroNome}` : ''}</h1>
                  <p>Bem-vindo à NEXUS CRVA. Selecione uma opção no menu para começar.</p>
                </div>
                <WelcomeDate>
                  <FaCalendarAlt size={13} />
                  <span>{dataHoje}</span>
                </WelcomeDate>
              </WelcomeMessage>

              {/* ── Logo + agenda do dia: com compromissos hoje, a agenda ocupa uma coluna à direita do logo,
                  em ordem de horário. No celular a agenda vem acima do logo. */}
              <HomeBody>
                <LogoSection>
                  <LogoContainer>
                    <LogoImage src="/logo_fundo_branco.png" alt="NEXUS CRVA" />
                  </LogoContainer>
                </LogoSection>

                {lembretesHoje.length > 0 && (
                  <AgendaPanel>
                    <AgendaHeader>
                      <FaCalendarAlt size={15} />
                      <span>Agenda de hoje</span>
                      <AgendaCount>{lembretesHoje.length}</AgendaCount>
                    </AgendaHeader>
                    <AgendaList>
                      {lembretesHoje.map((lembrete) => (
                        <AgendaItem key={lembrete.idLembrete} onClick={() => navigate('/agenda')} title="Abrir na Agenda">
                          <AgendaHora>{lembrete.horaLembrete || '--:--'}</AgendaHora>
                          <AgendaItemBody>
                            <strong>{lembrete.titulo}</strong>
                            {/* Com quem é o compromisso (Agenda -> Cliente) */}
                            {lembrete.nomeCliente && (
                              <span className="cliente"><FaUser size={10} /> {lembrete.nomeCliente}</span>
                            )}
                            {lembrete.observacoes && <p>{lembrete.observacoes}</p>}
                          </AgendaItemBody>
                          <AgendaDoneButton
                            type="button"
                            title="Já foi feito — tirar da tela"
                            aria-label={`Concluir ${lembrete.titulo}`}
                            onClick={(e) => { e.stopPropagation(); concluirLembrete(lembrete); }}
                          >
                            <FaTimes size={11} />
                          </AgendaDoneButton>
                        </AgendaItem>
                      ))}
                    </AgendaList>
                  </AgendaPanel>
                )}
              </HomeBody>

              {usefulLinks.length > 0 && (
                <LinksSection>
                  <SectionTitle>
                    <FaLink size={13} style={{ marginRight: '8px' }} />
                    Links Úteis
                  </SectionTitle>
                  <LinksGrid>
                    {usefulLinks.map((link, index) => (
                      <UsefulLinkCard
                        key={index}
                        style={{ '--cor-link': link.color || '#7f8c8d' }}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LinkBadge>
                          <FaGlobe size={16} />
                        </LinkBadge>
                        <LinkContent>
                          <LinkTitle>{link.title}</LinkTitle>
                          <LinkUrl>{link.url}</LinkUrl>
                        </LinkContent>
                        <LinkIcon>
                          <FaExternalLinkAlt size={12} />
                        </LinkIcon>
                      </UsefulLinkCard>
                    ))}
                  </LinksGrid>
                </LinksSection>
              )}
            </ContentArea>
          </MainContent>

          {/* Password Update Modal */}
          <Modal
            isOpen={showModal}
            style={{
              overlay: { backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 1000 },
              content: {
                top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                marginRight: '-50%', transform: 'translate(-50%, -50%)',
                maxWidth: '500px', width: '90%', padding: '40px',
                borderRadius: '15px', border: 'none',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
              },
            }}
            shouldCloseOnOverlayClick={false}
          >
            <ModalHeader>
              <h2 style={{ color: '#2c3e50', margin: 0 }}>Atualização de Senha Obrigatória</h2>
              <SecurityIcon>
                <FaExclamationTriangle size={20} color="#e74c3c" />
              </SecurityIcon>
            </ModalHeader>

            <PasswordRequirements>
              <h4 style={{ margin: '15px 0 10px 0', color: '#2c3e50' }}>Requisitos da senha:</h4>
              <ul style={{ paddingLeft: '20px', margin: 0, color: '#7f8c8d' }}>
                <li>Mínimo de 10 caracteres</li>
                <li>Pelo menos uma letra</li>
                <li>Pelo menos um número</li>
                <li>Pelo menos um caractere especial (!@#$%^&* etc.)</li>
              </ul>
            </PasswordRequirements>

            <form onSubmit={handleSubmit}>
              <FormField>
                <label>Senha atual:</label>
                <PasswordInput type="password" name="currentPassword" value={formData.currentPassword}
                  onChange={handleFormChange} hasError={!!formErrors.currentPassword}
                  placeholder="Digite sua senha atual" required />
                {formErrors.currentPassword && <ErrorMessage>{formErrors.currentPassword}</ErrorMessage>}
              </FormField>
              <FormField>
                <label>Nova senha:</label>
                <PasswordInput type="password" name="newPassword" value={formData.newPassword}
                  onChange={handleFormChange} hasError={!!formErrors.newPassword}
                  placeholder="Digite sua nova senha" required />
                {formErrors.newPassword && <ErrorMessage>{formErrors.newPassword}</ErrorMessage>}
              </FormField>
              <FormField>
                <label>Confirmar nova senha:</label>
                <PasswordInput type="password" name="confirmPassword" value={formData.confirmPassword}
                  onChange={handleFormChange} hasError={!!formErrors.confirmPassword}
                  placeholder="Confirme sua nova senha" required />
                {formErrors.confirmPassword && <ErrorMessage>{formErrors.confirmPassword}</ErrorMessage>}
              </FormField>
              <ButtonContainer>
                <SubmitButton type="submit">Atualizar Senha</SubmitButton>
              </ButtonContainer>
            </form>
          </Modal>

          {/* Relatório Modal */}
          <Modal
            isOpen={showRelatorioModal}
            onRequestClose={() => setShowRelatorioModal(false)}
            style={modalRelatorioStyles}
            contentLabel="Gerar Relatório de Caixa"
          >
            <ModalHeader>
              <h2><FaFilePdf style={{ marginRight: '10px' }} />Relatório de Caixa</h2>
              <CloseButton onClick={() => setShowRelatorioModal(false)}>×</CloseButton>
            </ModalHeader>
            <ModalContent>
              <FormGroup>
                <Label><FaCalendarAlt style={{ marginRight: '8px' }} />Data Início:</Label>
                <Input type="date" value={relatorioData.dataInicio}
                  onChange={(e) => setRelatorioData({ ...relatorioData, dataInicio: e.target.value })}
                  max={formatarDataParaAPI(new Date())} />
              </FormGroup>
              <FormGroup>
                <Label><FaCalendarAlt style={{ marginRight: '8px' }} />Data Fim:</Label>
                <Input type="date" value={relatorioData.dataFim}
                  onChange={(e) => setRelatorioData({ ...relatorioData, dataFim: e.target.value })}
                  max={formatarDataParaAPI(new Date())} min={relatorioData.dataInicio} />
              </FormGroup>
              <ButtonGroup>
                <FilterButton onClick={setPeriodoHoje}>
                  <FaCalendarAlt style={{ marginRight: '8px' }} />Usar Dia Atual
                </FilterButton>
                <ActionButton onClick={gerarRelatorioCaixa}
                  disabled={loadingRelatorio || !relatorioData.dataInicio || !relatorioData.dataFim}>
                  {loadingRelatorio ? 'Gerando...' : <><FaPrint style={{ marginRight: '8px' }} />Gerar Relatório PDF</>}
                </ActionButton>
              </ButtonGroup>
              {relatorioData.dataInicio && relatorioData.dataFim && (
                <InfoText>
                  Período selecionado: {new Date(relatorioData.dataInicio).toLocaleDateString('pt-BR')}
                  {' até '}
                  {new Date(relatorioData.dataFim).toLocaleDateString('pt-BR')}
                </InfoText>
              )}
            </ModalContent>
          </Modal>

          {/* ─── Modal de Requerimento DETRAN — continua funcionando normalmente ─── */}
          <RequerimentoDetranModal
            isOpen={showRequerimentoModal}
            onClose={() => setShowRequerimentoModal(false)}
            userData={userData}
          />
        </HomeContainer>
      )}
    </HomeBackground>
  );
};

// ─── Estilos ─────────────────────────────────────────────────────────────────

const HomeBackground = styled.div`
  background: #f2f5f7;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-x: hidden;
  font-family: 'Segoe UI', system-ui, -apple-system, Roboto, sans-serif;
  color: #1f2d33;
`;

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1600px;
  padding: 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const TopBar = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(16, 42, 51, 0.06);
  margin-bottom: 20px;
  border: 1px solid #e3e8eb;
  overflow: hidden;
`;

const TopBarContent = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  gap: 12px;
  box-sizing: border-box;
  flex-wrap: nowrap;

  @media (max-width: 600px) {
    padding: 10px 12px;
    gap: 8px;
  }
`;

const MenuToggleButton = styled.button`
  background: #f2f5f7;
  border: 1px solid #e3e8eb;
  color: #004d4d;
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #e6f2f1;
    border-color: #b9dcd8;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

const CompanyLogo = styled.div`
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 10px;
  background: #006d6d;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 34px;
    height: 34px;
    min-width: 34px;
  }
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const CompanyName = styled.h2`
  margin: 0;
  color: #1f2d33;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;

  @media (max-width: 768px) {
    font-size: 1rem;
    max-width: 160px;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    max-width: 110px;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  flex-wrap: nowrap;

  @media (max-width: 600px) {
    gap: 8px;
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

const UserWelcome = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const UserAvatar = styled.div`
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background: #006d6d;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: 480px) {
    display: none;
  }
`;

const UserName = styled.span`
  font-weight: 600;
  color: #1f2d33;
  font-size: 0.82rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;

  @media (max-width: 768px) {
    max-width: 80px;
  }
`;

const UserRole = styled.span`
  color: #6b7a80;
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  background: #ffffff;
  color: #b42318;
  border: 1px solid #f1c9c5;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.78rem;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;

  span {
    @media (max-width: 480px) {
      display: none;
    }
  }

  &:hover {
    background: #fdf1f0;
    border-color: #e6a39c;
  }
`;

const PlanInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  flex-shrink: 0;

  @media (max-width: 600px) {
    display: none;
  }
`;

const PlanInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
`;

const PlanLabel = styled.span`
  font-size: 0.62rem;
  color: #7f8c8d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
`;

const PlanContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  background: #f2f5f7;
  border-radius: 999px;
  border: 1px solid #e3e8eb;
  white-space: nowrap;
`;

const PlanIconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => {
    switch (props.tipoPlano) {
      case 'TESTE': return '#f39c12';
      case 'DEFINITIVO': return '#27ae60';
      case 'MENSAL': return '#008080';
      default: return '#7f8c8d';
    }
  }};
`;

const PlanText = styled.span`
  font-size: 0.78rem;
  font-weight: 600;
  color: ${props => {
    switch (props.tipoPlano) {
      case 'TESTE': return '#f39c12';
      case 'DEFINITIVO': return '#27ae60';
      case 'MENSAL': return '#008080';
      default: return '#7f8c8d';
    }
  }};
  white-space: nowrap;
`;

const TestDaysWarning = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #e74c3c;
  font-weight: 600;
  font-size: 0.68rem;
  padding: 2px 8px;
  background: rgba(231, 76, 60, 0.1);
  border-radius: 8px;
  white-space: nowrap;
  svg { flex-shrink: 0; }
`;

const MainContent = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  position: relative;
  align-items: flex-start;
  overflow-x: hidden;

  /* No desktop a altura acompanha o menu verde (o card do logo estica até o fim dele) */
  @media (max-width: 1023px) {
    min-height: calc(100vh - 140px);
  }
`;

const SidebarOverlay = styled.div`
  display: none;

  @media (max-width: 1023px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
  }
`;

const Sidebar = styled.aside`
  flex-shrink: 0;
  width: ${props => props.isOpen ? '260px' : '0px'};
  min-width: ${props => props.isOpen ? '260px' : '0px'};
  max-width: ${props => props.isOpen ? '260px' : '0px'};
  overflow: hidden;
  background: linear-gradient(160deg, #004d4d 0%, #008080 100%);
  border-radius: ${props => props.isOpen ? '15px' : '0'};
  box-shadow: ${props => props.isOpen ? '0 8px 25px rgba(0, 0, 0, 0.15)' : 'none'};
  transition: width 0.3s ease, min-width 0.3s ease, max-width 0.3s ease,
              box-shadow 0.3s ease, border-radius 0.3s ease;
  align-self: flex-start;
  position: relative;

  @media (max-width: 1023px) {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: ${props => props.isOpen ? '280px' : '0px'};
    min-width: 0;
    max-width: none;
    max-height: 100vh;
    border-radius: ${props => props.isOpen ? '0 15px 15px 0' : '0'};
    z-index: 100;
    align-self: auto;
  }
`;

const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.15);
`;

const SidebarTitle = styled.span`
  color: rgba(255,255,255,0.9);
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
`;

const SidebarCloseBtn = styled.button`
  background: rgba(255,255,255,0.1);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;

  &:hover { background: rgba(255,255,255,0.2); }

  @media (min-width: 1024px) {
    display: none;
  }
`;

const SidebarNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 10px;
  overflow-y: auto;
  max-height: calc(100vh - 70px);
`;

const SidebarItem = styled(Link)`
  display: flex;
  text-decoration: none;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  background: rgba(255,255,255,0.08);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  color: #ffffff;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.08);
  white-space: nowrap;

  &:hover {
    background: rgba(255,255,255,0.18);
    transform: translateX(4px);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  }

  &:active { transform: translateX(2px); }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  flex-shrink: 0;
  color: #ffffff;

  svg { width: 17px; height: 17px; }
`;

const ItemLabel = styled.span`
  font-size: 0.84rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

const NewTabIcon = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.55;
  flex-shrink: 0;
`;

const ContentArea = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  overflow-x: hidden;
`;

const WelcomeMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(16, 42, 51, 0.06);
  border: 1px solid #e3e8eb;
  border-left: 4px solid #006d6d;

  h1 {
    font-size: 1.45rem;
    color: #1f2d33;
    margin: 0 0 4px 0;
    font-weight: 700;
    letter-spacing: -0.01em;
    word-break: break-word;

    @media (max-width: 768px) { font-size: 1.2rem; }
    @media (max-width: 480px) { font-size: 1.05rem; }
  }

  p {
    font-size: 0.9rem;
    color: #6b7a80;
    font-weight: 400;
    margin: 0;

    @media (max-width: 480px) { font-size: 0.82rem; }
  }
`;

const WelcomeDate = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: #f2f5f7;
  border: 1px solid #e3e8eb;
  border-radius: 8px;
  color: #004d4d;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;

  svg { color: #006d6d; }
`;

const LogoSection = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 32px 24px;
  box-shadow: 0 1px 3px rgba(16, 42, 51, 0.06);
  text-align: center;
  border: 1px solid #e3e8eb;
  /* Ocupa a largura que a agenda do dia deixar, com o logo centralizado */
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1023px) {
    flex: none;
  }
`;

// Logo à esquerda e, quando há compromissos hoje, a agenda numa coluna à direita.
// Ocupa o espaço que sobrar na coluna, até o fim do menu verde.
const HomeBody = styled.div`
  flex: 1 0 auto;
  display: flex;
  gap: 20px;
  align-items: stretch;
  min-width: 0;

  @media (max-width: 1023px) {
    flex: none;
    flex-direction: column;
  }
`;

const AgendaPanel = styled.aside`
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  padding: 18px 16px;
  box-shadow: 0 1px 3px rgba(16, 42, 51, 0.06);
  border: 1px solid #e3e8eb;
  border-top: 4px solid #006d6d;
  box-sizing: border-box;
  min-width: 0;
  max-height: calc(100vh - 260px);

  @media (max-width: 1023px) {
    order: -1;
    flex-basis: auto;
    max-height: none;
  }
`;

const AgendaHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #004d4d;
  font-size: 1rem;
  font-weight: 700;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e3e8eb;

  svg { color: #006d6d; }
`;

const AgendaCount = styled.span`
  margin-left: auto;
  background: #20b2aa;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 22px;
  padding: 2px 7px;
  border-radius: 11px;
  text-align: center;
  box-sizing: border-box;
`;

const AgendaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  min-height: 0;
  padding-right: 2px;
`;

const AgendaItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #f0fdfa;
  border: 1px solid rgba(32,178,170,0.35);
  border-left: 4px solid #008080;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  min-width: 0;
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(16, 42, 51, 0.1);
    transform: translateY(-1px);
  }
`;

const AgendaHora = styled.span`
  flex-shrink: 0;
  padding: 2px 7px;
  border-radius: 6px;
  background: #008080;
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

const AgendaItemBody = styled.div`
  flex: 1;
  min-width: 0;

  strong {
    display: block;
    font-size: 0.88rem;
    font-weight: 700;
    color: #004d4d;
    word-break: break-word;
  }

  .cliente {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 3px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #008080;
    word-break: break-word;
  }

  p {
    margin: 4px 0 0 0;
    font-size: 0.78rem;
    color: #34495e;
    white-space: pre-wrap;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

const AgendaDoneButton = styled.button`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin: -2px -4px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #7f8c8d;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(231,76,60,0.12);
    color: #e74c3c;
  }
`;

const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  max-width: 500px;
  width: 100%;
  height: auto;
  object-fit: contain;

  @media (max-width: 768px) { max-width: 280px; }
  @media (max-width: 480px) { max-width: 200px; }
`;

const LinksSection = styled.div`width: 100%;`;

const SectionTitle = styled.h2`
  color: #6b7a80;
  font-size: 0.75rem;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;

  svg { color: #006d6d; }
`;

const LinksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const UsefulLinkCard = styled.a`
  display: flex;
  text-decoration: none;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #e3e8eb;
  border-left: 4px solid var(--cor-link);
  border-radius: 10px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  box-shadow: 0 1px 2px rgba(16, 42, 51, 0.04);
  color: #1f2d33;
  min-height: 60px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(16, 42, 51, 0.1);
    border-color: #cfd8dc;
    border-left-color: var(--cor-link);
  }

  &:hover > div:last-child {
    color: #006d6d;
  }
`;

const LinkBadge = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: var(--cor-link);
`;

const LinkContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const LinkTitle = styled.h3`
  margin: 0 0 2px 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1f2d33;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LinkUrl = styled.p`
  margin: 0;
  font-size: 0.72rem;
  color: #6b7a80;
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LinkIcon = styled.div`
  margin-left: 4px;
  color: #9aa7ad;
  flex-shrink: 0;
  transition: color 0.2s ease;
`;

const FormField = styled.div`
  margin-bottom: 20px;
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #2c3e50;
  }
`;

const ErrorMessage = styled.span`
  display: block;
  color: #e74c3c;
  font-size: 0.85rem;
  margin-top: 5px;
  font-weight: 500;
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #008080 0%, #20b2aa 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 128, 128, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 128, 128, 0.4);
  }
`;

const SecurityIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(231, 76, 60, 0.1);
`;

const PasswordRequirements = styled.div`
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 20px;
  border-left: 4px solid #008080;
  h4 { font-size: 1rem; font-weight: 600; }
  ul { font-size: 0.88rem; li { margin-bottom: 5px; } }
`;

const PasswordInput = styled.input`
  width: 100%;
  padding: 11px 14px;
  border: 2px solid ${props => props.hasError ? '#e74c3c' : '#ddd'};
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#e74c3c' : '#008080'};
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(231, 76, 60, 0.1)' : 'rgba(0, 128, 128, 0.1)'};
  }
  &::placeholder { color: #adb5bd; }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

const modalRelatorioStyles = {
  overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000 },
  content: {
    top: '50%', left: '50%', right: 'auto', bottom: 'auto',
    marginRight: '-50%', transform: 'translate(-50%, -50%)',
    maxWidth: '500px', width: '90%', borderRadius: '12px',
    padding: '0', border: 'none', boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
  }
};

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #008080 0%, #20b2aa 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  h2 { margin: 0; font-size: 1.3rem; display: flex; align-items: center; }
`;

const CloseButton = styled.button`
  background: none; border: none; color: white;
  font-size: 24px; cursor: pointer; padding: 4px;
  border-radius: 50%; width: 30px; height: 30px;
  display: flex; align-items: center; justify-content: center;
  &:hover { background: rgba(255, 255, 255, 0.1); }
`;

const ModalContent = styled.div`padding: 24px; background: #fff;`;

const FormGroup = styled.div`margin-bottom: 20px;`;

const Label = styled.label`
  display: flex; align-items: center;
  margin-bottom: 8px; font-weight: 600; color: #2c3e50;
`;

const Input = styled.input`
  width: 95%; padding: 11px 14px;
  border: 2px solid #ddd; border-radius: 8px; font-size: 15px;
  transition: border-color 0.3s ease;
  &:focus { outline: none; border-color: #008080; box-shadow: 0 0 0 3px rgba(0, 128, 128, 0.1); }
`;

const ButtonGroup = styled.div`
  display: flex; gap: 12px; margin-bottom: 20px; flex-wrap: wrap;
`;

const FilterButton = styled.button`
  flex: 1; padding: 11px 18px;
  background: #f8f9fa; color: #2c3e50;
  border: 2px solid #dee2e6; border-radius: 8px;
  cursor: pointer; font-weight: 600;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.3s ease; min-width: 130px;
  &:hover { background: #e9ecef; }
`;

const ActionButton = styled.button`
  flex: 2; padding: 11px 18px;
  background: ${props => props.disabled ? '#6c757d' : 'linear-gradient(135deg, #008080 0%, #20b2aa 100%)'};
  color: white; border: none; border-radius: 8px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-weight: 600; display: flex; align-items: center; justify-content: center;
  transition: all 0.3s ease; min-width: 180px;
  opacity: ${props => props.disabled ? 0.6 : 1};
  &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 4px 15px rgba(0, 128, 128, 0.4); }
`;

const InfoText = styled.p`
  text-align: center; color: #6c757d; font-size: 13px; margin: 0;
  padding: 10px; background: #f8f9fa; border-radius: 6px;
  border-left: 4px solid #008080;
`;

export default Home;
